<template>
    <div 
        class="formfield" 
        :class="{'formfield--error': (error)}">
        <label
            v-if="label"
            class="formfield__label">
            {{ label }}
            <span
                class="required"
                v-if="required">*</span>
        </label>
        <div class="formfield__input formfield__date">
            <div class="formfield__date__inner">
                <input 
                    type="date" 
                    ref="currentValue"
                    :name="name"
                    @focus="removeError" 
                    :placeholder="placeholder" >

                <div
                    class="formfield__icon"
                    @click="openDateField()"
                    v-if="!(options.allowEmpty && selectedValue)">
                    <i class="icon-calendar" />
                </div>

                <a
                    class="formfield__icon formfield__date__icon--clear"
                    v-if="options.allowEmpty && selectedValue"
                    @click="clear">
                    <i class="icon-close" />
                </a>
            </div>

            <div 
                class="formfield__error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
import Flatpickr from 'flatpickr';
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import moment from 'moment';

export default {
    $_veeValidate: {
        value () {
            return this.$refs.currentValue.value;
        }
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        errors: {
            type: Object,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        options: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        error() {
            if(this.errors) {
                return this.errors.first(this.name);
            }

            return null;
        },
        inputType() {
            return this.type || 'text';
        },
    },
    data() {
        return {
            flatpickr: null,
            selectedValue: this.value
        };
    },
    watch: {
        value() {
            if(this.flatpickr) {
                if(this.value === null) {
                    this.flatpickr.clear();
                    this.updateValue('');
                }
            }
        }
    },
    mounted() {
        this.defaults = {
            locale: Dutch,
            hourIncrement: false,
            defaultDate: this.value ? moment(this.value).format('D MMMM YYYY') : null,
            minDate: new Date(2006, 0, 10),
            dateFormat: 'j F Y',
            disableMobile: true,
            onChange: (selectedDates) => {
                this.updateValue(selectedDates[0]);   
            }
        };

        this.flatpickr = new Flatpickr(this.$el.querySelector('input'), Object.assign({}, this.defaults, this.options));
        
        if(this.flatpickr.selectedDates[0]) {
            this.updateValue(this.flatpickr.selectedDates[0]); 
        }
    },
    methods: {
        removeError() {
            if(this.errors) {
                this.errors.remove(this.name);
            }
        },
        updateValue(value) {
            let formatted = '';

            if(value) {
                formatted = moment(value).format('YYYY-MM-DD');
            }

            this.selectedValue = formatted;
            this.$emit('input', formatted);
        },
        openDateField() {
            if(this.flatpickr) {
                this.flatpickr.open();
            }
        },
        clear() {
            if(this.flatpickr) {
                this.flatpickr.clear();
            }
        }
    },
};
</script>
